const flatten = (array) => [].concat(...array);
function extractSkuQuantityPairsFromLineItems(lineItems) {
  return flatten(
    lineItems.map((lineItem) => {
      if ("sku" in lineItem) {
        return [
          {
            sku: lineItem.sku,
            quantity: lineItem.quantity
          }
        ];
      }
      return [lineItem.frame, lineItem.lensType, lineItem.lensPackage, lineItem.addOn].map(
        (item) => ({
          sku: item?.sku || "",
          quantity: 1
        })
      );
    })
  );
}
export {
  extractSkuQuantityPairsFromLineItems
};
//# sourceMappingURL=extract-sku-qauntity-pairs.js.map
